import { HintTypeEnum } from '@nankai/online/constants';

export default {
  seat: {
    parenthesis: '({{text}})',
    header: {
      station: 'Please enter your purchase information.',
      seat: 'Please select the seat.',
      start: 'departure at {{time}}',
      confirm: 'Seat Confirmation',
      bookingConfirm:
        '* The seat will only be officially reserved after payment and booking are completed.'
    },
    button: {
      back: 'Back',
      next: 'Next',
      change: 'Change'
    },
    confirmChange: {
      title: 'Your reservation will be changed as follows.',
      before: 'Before',
      after: 'After',
      label: {
        trainName: 'Train',
        date: 'Date',
        time: 'Time',
        seat: 'Seat',
        seatWithCar: 'Seat (Car {{carNo}})'
      }
    },
    selectSeatType: {
      title: 'Seat selection method',
      auto: 'Auto assignment',
      manual: 'Manual selection'
    },
    station: {
      date: 'Date',
      startStation: 'Departure station',
      endStation: 'Arrival station',
      startStationTip: 'Please select the departure station',
      endStationTip: 'Please select the arrival station'
    },
    hintType: {
      [HintTypeEnum.OutOfAvailableTerm]:
        'The sale begins 1 month before the boarding date. The selected date is invalid.',
      [HintTypeEnum.EndOfService]:
        'No trains are available for purchase.<br />Please check the operation information.'
    },
    train: {
      header: 'Please select the train.',
      emptySeat: 'Empty seat',
      trainLabel: '{{trainName}} {{trainServiceNo}}'
    },
    carriage: {
      carriageCar: 'Car No.{{carNo}}',
      directionUpTitle: '↑ Toward Namba',
      directionDownTitle: '↑ Toward Koyasan',
      car1Notice1: '【Notice】Seats No. 2, 4, 23, and 27 do not have windows.',
      car1Notice2:
        "Please note that the front view is not visible because of the partition wall behind the driver's cabin."
    },
    wheelchairConfirm: {
      title: 'You have selected a wheelchair seat.',
      content:
        'This seat is reserved exclusively for customers using a wheelchair. Please review the following:',
      notice1:
        'This seat may only be used by customers who will be visiting with a wheelchair.',
      notice2: 'Use by general customers is not permitted.',
      confirmText: 'Would you like to continue with this selection?',
      cancel: 'Cancel',
      confirm: 'Yes'
    }
  },
  error: {
    invalidParams:
      'The specified conditions are invalid. Please start over from the beginning',
    lineIdInvalid:
      'No line has been selected. Please start over from the beginning',
    productIdInvalid:
      'The selected seat type is invalid. Please start over from the beginning',
    forbidden:
      'This operation is not allowed. Please start over from the beginning',
    seatChangeCountExceeded: 'The number of seat changes is limited to 2 times',
    notFound:
      'The page you are looking for cannot be found. Please start over from the beginning',
    system: 'A system error has occurred. Please try again later'
  }
};
